// src/constants/apiConstants.js
export const API_COLORS = {
  LOGIN_BUTTON: '#0077cc',
  NAV_BACKGROUND_DEFAULT: '#ffffff',
  NAV_FOREGROUND: '#000000',
};

export const API_HEADER = {
  AUTH_PREFIX: 'Bearer',
  ACCEPT_JSON: 'application/json',
  CONTENT_TYPE_FORM: 'application/x-www-form-urlencoded',
  CONTENT_TYPE_JSON: 'application/json',
};

export const API_STATUS = {
  OK: 200,
   NO_CONTENT: 204,
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
};

export const API_ERRORS = {
  FETCH_TOKEN: 'Failed to fetch token',
  INVALID_REQUEST: 'Invalid request',
  LOGIN_FAILED: 'Login failed',
   SAVE_FAILED: 'Failed to save FCM token', // New error
  DELETE_FAILED: 'Failed to delete FCM token', // New error
};